const CONFIG = {
  host: 'localhost:4001',
  host_endpoint: '/api/animal',
  host_survey: '/api/survey',
  host_cint: '/api/cint',
  host_quiz: '/api/quiz',
  host_google: '/api/google',
  requestSurvey: '/getsurvey/',
  requestQuestion: '/getcard/',
  submitGoogle: '/googlesearch/',
  saveUser: '/saveuser/',
  spellCheck: '/spellcheck',
  submitAnalyze: '/analyze/',
  submitAnswer: '/saveanswer/',
  quizSave: '/answerQuiz',
  setStatus: '/setStatus',
  cintSave: '/setCintStatus',
  verifyTurnstile: '/verifyTurnstile',
  getAttentionChallenge: '/getAttentionChallenge',
  verifyAttention: '/verifyAttention',
  cintHost5: 'https://notch.insights.supply/cb?token=cb73b6ee-8844-46da-9e53-c2dd9728e2bc&RID=',
  cintHost2: 'https://s.cint.com/Survey/EarlyScreenOut?ProjectToken=',
};
export default CONFIG;
